import script from "./MasterLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./MasterLink.vue?vue&type=script&lang=ts&setup=true"

import "./MasterLink.vue?vue&type=style&index=0&id=09422416&scoped=true&lang=css"

import exportComponent from "/home/deployment/actions-runner/_work/pwscorecards-vue/pwscorecards-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09422416"]])

export default __exports__